import alphabet from './modules/alphabet'
import alphanumeric from './modules/alphanumeric'
import kana from './modules/kana'
import mail from './modules/mail'
import number from './modules/number'
import numberHyphen from './modules/numberHyphen'
import password from './modules/password'
import required from './modules/required'
import requiredBool from './modules/requiredBool'
import url from './modules/url'

/**
 * バリデーション
 */
export default {
  alphabet,
  alphanumeric,
  kana,
  mail,
  number,
  numberHyphen,
  password,
  required,
  requiredBool,
  url
}
